import React, { useState } from "react"
import { IoClose } from "react-icons/io5"
import Modal from "react-modal"

import cn from "@fuse/utils/cn"

export const InfoModalComponent = ({
  ctaComponent,
  modalContent,
  className,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const onClose = () => {
    setIsOpen(false)
  }
  React.useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        onClose()
      }
    }

    if (isOpen) {
      window.addEventListener("keydown", handleEsc)
    }

    return () => {
      window.removeEventListener("keydown", handleEsc)
    }
  }, [isOpen, onClose])

  return (
    <>
      <div onClick={() => setIsOpen(true)}>{ctaComponent}</div>
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        overlayClassName="fixed inset-0 bg-black/20 z-[1000] flex items-center justify-center"
        className={cn(
          "relative bg-black/30 backdrop-blur-md rounded-xl shadow-lg flex flex-col w-full max-w-sm outline-none border-0",
          className,
        )}
        shouldCloseOnOverlayClick={true}
        ariaHideApp={false}
        {...props}
      >
        <button
          onClick={onClose}
          className="absolute right-[10px] top-[10px] p-0 z-[10] bg-transparent"
          aria-label="Close"
        >
          <IoClose className="text-white/70" />
        </button>
        {modalContent}
      </Modal>
    </>
  )
}
